/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_BodyInputs */

const en_backstage_body = /** @type {(inputs: Backstage_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operations, buying, finance and customer service share one place. The home says what to do now, ⌘K reaches any order, line or supplier in a few keystrokes, and a change made anywhere shows up on every open screen.`)
};

/**
* | output |
* | --- |
* | "Operations, buying, finance and customer service share one place. The home says what to do now, ⌘K reaches any order, line or supplier in a few keystrokes, a..." |
*
* @param {Backstage_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_body = /** @type {((inputs?: Backstage_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_body(inputs)
});